var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_4603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2279 2.76816C21.9875 2.65733 20.4718 2.65734 18.5543 2.65735H18.4457C16.5281 2.65734 15.0124 2.65733 13.7721 2.76816C12.4979 2.88201 11.4323 3.11795 10.4251 3.63464C10.1642 3.76848 9.91006 3.91518 9.6637 4.07421C8.71264 4.68812 7.97547 5.49306 7.23982 6.53956C6.52364 7.55834 5.7658 8.87098 4.80704 10.5316L4.75275 10.6257C3.79396 12.2863 3.03611 13.5989 2.5119 14.7285C1.97343 15.8889 1.64492 16.9298 1.58879 18.0604C1.57425 18.3532 1.57425 18.6466 1.58879 18.9395C1.64492 20.0701 1.97343 21.111 2.5119 22.2713C3.03609 23.4009 3.79392 24.7135 4.75266 26.3741L4.80701 26.4682C5.76578 28.1289 6.52364 29.4415 7.23982 30.4603C7.97547 31.5068 8.71264 32.3118 9.6637 32.9257C9.91006 33.0847 10.1642 33.2314 10.4251 33.3653C11.4323 33.8819 12.4979 34.1179 13.7721 34.2317C15.0124 34.3426 16.5281 34.3426 18.4456 34.3425H18.5543C20.4718 34.3426 21.9875 34.3426 23.2279 34.2317C24.502 34.1179 25.5677 33.8819 26.5749 33.3653C26.8358 33.2314 27.0899 33.0847 27.3363 32.9257C28.2873 32.3118 29.0245 31.5068 29.7601 30.4603C30.4763 29.4416 31.2341 28.1289 32.1929 26.4683L32.2472 26.3742C33.206 24.7136 33.9639 23.401 34.4881 22.2713C35.0265 21.111 35.355 20.0701 35.4112 18.9395C35.4257 18.6467 35.4257 18.3532 35.4112 18.0604C35.355 16.9298 35.0265 15.8889 34.4881 14.7286C33.9639 13.5989 33.206 12.2863 32.2472 10.6256L32.1929 10.5315C31.2341 8.87093 30.4763 7.55833 29.7601 6.53956C29.0245 5.49306 28.2873 4.68812 27.3363 4.07421C27.0899 3.91518 26.8358 3.76848 26.5749 3.63464C25.5677 3.11795 24.502 2.88201 23.2279 2.76816Z",
    fill: "#F7AEB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2279 2.76816C21.9875 2.65733 20.4718 2.65734 18.5543 2.65735H18.4457C16.5281 2.65734 15.0124 2.65733 13.7721 2.76816C12.4979 2.88201 11.4323 3.11795 10.4251 3.63464C10.1642 3.76848 9.91006 3.91518 9.6637 4.07421C8.71264 4.68812 7.97547 5.49306 7.23982 6.53956C6.52364 7.55834 5.7658 8.87098 4.80704 10.5316L4.75275 10.6257C3.79396 12.2863 3.03611 13.5989 2.5119 14.7285C1.97343 15.8889 1.64492 16.9298 1.58879 18.0604C1.57425 18.3532 1.57425 18.6466 1.58879 18.9395C1.64492 20.0701 1.97343 21.111 2.5119 22.2713C3.03609 23.4009 3.79392 24.7135 4.75266 26.3741L4.80701 26.4682C5.76578 28.1289 6.52364 29.4415 7.23982 30.4603C7.97547 31.5068 8.71264 32.3118 9.6637 32.9257C9.91006 33.0847 10.1642 33.2314 10.4251 33.3653C11.4323 33.8819 12.4979 34.1179 13.7721 34.2317C15.0124 34.3426 16.5281 34.3426 18.4456 34.3425H18.5543C20.4718 34.3426 21.9875 34.3426 23.2279 34.2317C24.502 34.1179 25.5677 33.8819 26.5749 33.3653C26.8358 33.2314 27.0899 33.0847 27.3363 32.9257C28.2873 32.3118 29.0245 31.5068 29.7601 30.4603C30.4763 29.4416 31.2341 28.1289 32.1929 26.4683L32.2472 26.3742C33.206 24.7136 33.9639 23.401 34.4881 22.2713C35.0265 21.111 35.355 20.0701 35.4112 18.9395C35.4257 18.6467 35.4257 18.3532 35.4112 18.0604C35.355 16.9298 35.0265 15.8889 34.4881 14.7286C33.9639 13.5989 33.206 12.2863 32.2472 10.6256L32.1929 10.5315C31.2341 8.87093 30.4763 7.55833 29.7601 6.53956C29.0245 5.49306 28.2873 4.68812 27.3363 4.07421C27.0899 3.91518 26.8358 3.76848 26.5749 3.63464C25.5677 3.11795 24.502 2.88201 23.2279 2.76816Z",
    stroke: "url(#paint0_linear_1_4603)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3271 16.1949C25.2402 13.9773 23.0227 11.7598 20.8052 12.6729L16.6784 14.3722C15.633 14.8027 14.8028 15.6328 14.3723 16.6782L12.673 20.8051C11.7599 23.0226 13.9775 25.2401 16.195 24.327L20.3218 22.6277C21.3672 22.1973 22.1974 21.3671 22.6279 20.3217L24.3271 16.1949Z",
    fill: "url(#paint1_linear_1_4603)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_4603",
    x: -22.9221,
    y: -21.8427,
    width: 82.8442,
    height: 80.6852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4603",
    x: 9.20651,
    y: 9.20639,
    width: 25.0988,
    height: 25.0988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.25583,
    dy: 3.25583
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25583
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4603",
    x1: 1.57788,
    y1: 2.65735,
    x2: 33.2125,
    y2: 36.4133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4603",
    x1: 18.6018,
    y1: 27.1103,
    x2: 35.2679,
    y2: 10.7734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.df75b33d95fffe0f92bf48a36d95eeeb.svg";
export { ForwardRef as ReactComponent };